import JourneyCasesEvents from '@/components/journey_cases/utils/Events'

export default [...JourneyCasesEvents]
